import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { FormElementGetAllService } from '../../services';

export const fetchFormElementGetAll = createAsyncThunk(
    'formElementGetAll/fetchFormElementGetAll',
    async () => {
        const response = await FormElementGetAllService()
        return response.result
    }
);

const formElementGetAllSlice = createSlice({
    name: 'formElementGetAll',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchFormElementGetAll.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchFormElementGetAll.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchFormElementGetAll.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default formElementGetAllSlice.reducer;
